import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form-group col-12" }
const _hoisted_2 = { class: "form-group col-12" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Group Time", -1)
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<option value=\"\">None</option><option value=\"hour\">Hour</option><option value=\"day\">Day</option><option value=\"week\">Week</option><option value=\"month\">Month</option>", 5)
const _hoisted_9 = [
  _hoisted_4
]
const _hoisted_10 = { class: "form-group col-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_next_date_range_picker = _resolveComponent("next-date-range-picker")!
  const _component_offer_selector = _resolveComponent("offer-selector")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_next_date_range_picker, {
        modelValue: _ctx.filters.dates,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters.dates) = $event)),
        format: 'DD/MM/YYYY HH:mm',
        block_minutes: true,
        onShortcutUpdated: _cache[1] || (_cache[1] = (v) => {_ctx.filters.shortcut_chosen = v})
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _withDirectives(_createElementVNode("select", {
        class: "form-control form-control-sm form-control-solid form-control-xs",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters.group_timeframe) = $event))
      }, _hoisted_9, 512), [
        [_vModelSelect, _ctx.filters.group_timeframe]
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_offer_selector, {
        modelValue: _ctx.filters.offer_id,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters.offer_id) = $event))
      }, null, 8, ["modelValue"])
    ])
  ], 64))
}